import axios from 'axios';
import { clearStorage, getItemStorage } from 'services/storage';
import { tokenKey } from 'constants/storage';
import { openNotification } from 'utils/notification';

export const baseURL = 'https://dpohub-api.daniel-ip.com/';
// export const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:8170/';
// export const baseURL = 'https://api-dpohub-stage.daniel-ip.com/';

const api = axios.create({
  baseURL: baseURL + 'api',
});

api.interceptors.request.use(config => {
  if (getItemStorage(tokenKey) !== null) {
    config.headers.Authorization = `Bearer ${getItemStorage(tokenKey)}`;
  }

  return config;
});

api.interceptors.response.use(undefined, error => {
  if (error?.response?.status === 400 || error?.response?.status === 500) {
    if (error?.response?.data?.message === 'No message available') {
      openNotification('Ocorreu algum erro ao efetuar a operação', 'error');
    } else {
      openNotification(error.response.data.message, 'error');
    }
  } else if (error?.response.status === 400) {
    openNotification('errooorr', 'error');
  } else if (error?.response?.status === 401) {
    openNotification('Login expirado, por favor logue novamente', 'error');
    clearStorage();
    clearStorage(true);
    setTimeout(() => {
      location.href = '/login';
    }, 3000);
  }

  return Promise.reject(error);
});

export const authApi = axios.create({ baseURL });
export default api;
